import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import { lotUrl } from '../../helpers/urlBuilder';

/**
 * Table cell with link to lot
 *
 * @param {{}} props
 * @constructor
 */
function LotCell(props) {
    return (
        props.customCell.options.uid &&
        props.customCell.options.date &&
        props.customCell.options.letter ?
            <a
                href={lotUrl(
                    props.rowData[props.customCell.options.uid] || props.customCell.options.uid,
                    props.rowData[props.customCell.options.date] || props.customCell.options.date,
                    props.rowData[props.columnName],
                    props.rowData[props.customCell.options.letter]
                )}
                className="ui-link ui-link_table"
            >
                {props.rowData[props.columnName]}{props.rowData[props.customCell.options.letter]}
                <Svg
                    iconName="right"
                    size="XSmall"
                />
            </a> :
            <span>
                {props.rowData[props.columnName]}
                {props.rowData[props.customCell.options.letter]}
            </span>
    );
}

LotCell.propTypes = {
    /**
     * Single row data
     */
    rowData: PropTypes.object.isRequired,
    /**
     * Name of current column
     */
    columnName: PropTypes.string.isRequired,
    /**
     * Custom cell component and options
     */
    customCell: PropTypes.object.isRequired
};

export default LotCell;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/LotCell.js